import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import FileDownload from 'react-file-download';
import PpcUsersList from './ppc-list';
import PpcSearch from './ppc-search';
import {getPpcManagementList} from '../../../../actions/ppc';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import irelandApi from '../../../../irelandApi';

class PpcManagement extends Component {
  handleInputChange = (e) => {
    this.setState({searchValue: e.target.value});
  };
  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };
  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };
  handleSearch = () => {
    const {
      searchValue, dateFrom, dateTo, pageNumber
    } = this.state;
    this.props.dispatch(getPpcManagementList(searchValue, dateFrom, dateTo, pageNumber));
  };
  handleClear = () => {
    this.setState({
      searchValue: '',
      dateFrom: '',
      dateTo: '',
      pageNumber: 1
    }, this.handleSearch);
  };
  handlePageChange = (page) => {
    this.handleSearch();
    this.setState({pageNumber: page});
  };
  downloadCSV = (url) => {
    irelandApi.get(url, {headers: {Accept: 'text/csv'}})
      .then((response) => {
        FileDownload(response.data, 'unprocessed_ppc_orders.csv');
      })
      .catch(() => {

      });
  };

  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      dateFrom: '',
      dateTo: '',
      pageNumber: 1
    };
  }

  componentWillMount() {
    this.props.dispatch(getPpcManagementList());
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="ppc-management">
        <Row>
          <Col md={12}>
            <PageTitle className="pull-left">
              Prepaid card management
            </PageTitle>
            <ArrowButton
              arrow={false}
              className="pull-right"
              onClick={() => {
                this.downloadCSV(this.props.links['unprocessed-orders']);
              }}
              submit={false}
            >
              Unprocessed orders
            </ArrowButton>
          </Col>
        </Row>

        <Row className="mg-top-10">
          <Col md={12}>
            <PpcSearch
              dateFromValue={this.state.dateFrom}
              dateToValue={this.state.dateTo}
              onClear={this.handleClear}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onInputChange={this.handleInputChange}
              onSearch={this.handleSearch}
              searchValue={this.state.searchValue}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PpcUsersList
              currentPage={this.state.pageNumber}
              fetched={this.props.fetched}
              fetching={this.props.fetching}
              onPageChange={this.handlePageChange}
              pagination={this.props.pagination}
              users={this.props.users}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  users: state.ppc.management.list,
  pagination: state.ppc.management.paging,
  links: state.ppc.management.links,
  fetching: state.ppc.fetching,
  fetched: state.ppc.fetched
});

export default connect(mapStateToProps)(PpcManagement);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/management/index.jsx